import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/', label: '首页' },
  { to: '/category/movie', label: '电影' },
  { to: '/category/tv', label: '电视剧' },
  { to: '/category/variety', label: '综艺' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const submitSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 gap-4">
          <Link to="/" className="flex items-center gap-2 cursor-pointer shrink-0" onClick={() => setMenuOpen(false)}>
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-play-circle-fill text-xl"></i>
            </span>
            <span className="leading-tight">
              <span className="block text-sm md:text-base font-heading font-bold text-foreground-950">中文字幕</span>
              <span className="block text-[10px] md:text-xs text-foreground-500 tracking-wide">四虎在线 · 影视</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="hidden md:flex items-center gap-2 shrink-0">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视剧..."
                aria-label="搜索影视剧"
                className="w-44 lg:w-56 pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300"
              />
            </div>
            <button
              type="submit"
              className="px-4 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-fade-in">
          <form onSubmit={submitSearch} className="relative mb-4">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视剧..."
              aria-label="搜索影视剧"
              className="w-full pl-9 pr-3 py-3 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            />
          </form>
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-200'
                  }`
                }
              >
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}